import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NzCheckboxModule } from 'ant-reset-private/checkbox';
import { NzAddOnModule } from 'ant-reset-private/core';
import { NzDropDownModule } from 'ant-reset-private/dropdown';
import { NzEmptyModule } from 'ant-reset-private/empty';
import { NzI18nModule } from 'ant-reset-private/i18n';
import { NzIconModule } from 'ant-reset-private/icon';
import { NzMenuModule } from 'ant-reset-private/menu';
import { NzPaginationModule } from 'ant-reset-private/pagination';
import { NzRadioModule } from 'ant-reset-private/radio';
import { NzResizableModule } from 'ant-reset-private/resizable';
import { NzSpinModule } from 'ant-reset-private/spin';

import { NzTableComponent } from './nz-table.component';
import { NzTbodyDirective } from './nz-tbody.directive';
import { NzTdComponent } from './nz-td.component';
import { NzThComponent } from './nz-th.component';
import { NzTheadComponent } from './nz-thead.component';
import { NzTrDirective } from './nz-tr.directive';
import { NzVirtualScrollDirective } from './nz-virtual-scroll.directive';

@NgModule({
  declarations: [
    NzTableComponent,
    NzThComponent,
    NzTdComponent,
    NzTheadComponent,
    NzTbodyDirective,
    NzTrDirective,
    NzVirtualScrollDirective
  ],
  exports: [
    NzTableComponent,
    NzThComponent,
    NzTdComponent,
    NzTheadComponent,
    NzTbodyDirective,
    NzTrDirective,
    NzVirtualScrollDirective
  ],
  imports: [
    NzMenuModule,
    FormsModule,
    NzAddOnModule,
    NzRadioModule,
    NzCheckboxModule,
    NzDropDownModule,
    CommonModule,
    NzPaginationModule,
    NzSpinModule,
    NzI18nModule,
    NzIconModule,
    NzEmptyModule,
    ScrollingModule,
    NzResizableModule
  ]
})
export class NzTableModule {}
